import { LangCode, DEFAULT_LANG } from './types';

const STORAGE_KEY = 'skinbloom.lang';
const SUPPORTED: LangCode[] = ['ru', 'en', 'pl'];

function isSupported(code: string): code is LangCode {
  return (SUPPORTED as string[]).includes(code);
}

// Resolve language on first load:
//  1. Saved choice in localStorage (user picked it manually before)
//  2. Browser language(s) — match by 2-letter prefix
//  3. Fallback to DEFAULT_LANG ('en')
export function detectInitialLang(): LangCode {
  if (typeof window === 'undefined') return DEFAULT_LANG;

  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved && isSupported(saved)) return saved;
  } catch {
    // localStorage may be unavailable (private mode, SSR, etc.) — fall through.
  }

  const candidates: string[] = [];
  if (typeof navigator !== 'undefined') {
    if (Array.isArray(navigator.languages)) candidates.push(...navigator.languages);
    if (navigator.language) candidates.push(navigator.language);
  }

  for (const raw of candidates) {
    const prefix = raw.toLowerCase().split('-')[0];
    if (isSupported(prefix)) return prefix;
  }

  return DEFAULT_LANG;
}

export function persistLang(lang: LangCode): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    /* ignore */
  }
}
